import { useCurrentLesson } from '@hooks/useCurrentLesson'
import { useGetCourseContent } from '@services/api/graphql/getCourseContent'
import { useLocalSearchParams } from 'expo-router'
import { BaseImageViewer } from './BaseImageViewer'

export function ImageViewerPage() {
  const { currentLesson } = useCurrentLesson()
  const { courseId, enrollmentId } = useLocalSearchParams()

  const { data: courseContent, loading: isLoadingCourseContent } =
    useGetCourseContent({
      id: Number(currentLesson?.courseContentId) ?? 0,
      courseId: Number(courseId) ?? 0,
      enrollmentId: Number(enrollmentId) ?? 0,
    })

  const media = currentLesson?.media
  const fileUrl = courseContent?.courseContent?.lesson?.media?.fileUrl

  return (
    <BaseImageViewer
      media={media}
      fileUrl={fileUrl}
      isLoading={isLoadingCourseContent}
    />
  )
}
